import { render } from "./signupView.vue?vue&type=template&id=b648a2cc"
import script from "./signupView.vue?vue&type=script&lang=js"
export * from "./signupView.vue?vue&type=script&lang=js"

import exportComponent from "/home/marc/E09/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__